import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
    namespaced: true,
    state() {
        return {
          articles: [],
          searchingPDBArticles: true,
          nextUrl: "",
          previousUrl: "",
          totalArticles: 0,
          limitError: "",
          sources: "",
          searchingPdbSources: true,
          insightsSources: "",
          searchingInsightsSources: true,
          insights: [],
          searchingInsightsArticles: true,
          articleSearchHistory: {},
          savedSearchFilter: {},
          discoverArticleComments: [],
          topicComments: [],
          privateTopicComments: [],
          publicTopicComments: [],
          discussionSkeletonLoader: true,
          searchQuery: "",
          seachedTopic: "",
          startDate: "",
          endDate: "",
          insightsStartDate: "",
          insightsEndDate: "",
          includedSources: "",
          excludedSources: "",
          insightsIncludedSources: "",
          insightsExcludedSources: "",
          invitedTopicURL: "",
          topicDetails: "",
          invitedArticleId: null,
          totalResults: {},
          currentPage: 0,
          fetchedSources: [],
          updateSources: false,
          sortFilter: "",
          fetchedInsightsSources: [],
          selectedIncludeSources: [],
          selectedExcludeSources: [],
          selectedInsightsIncludeSources: [],
          selectedInsightsExcludeSources: [],
          articleReadView: false,
          filterCounts: 0,
          topicRoute: "",
          selectedSpecificSources: [],
          oldTopics: [],
          discussionCollapse: "0",
          topicSource: false,
          discoverModules: [],
          insightsNextUrl: "",
          insightsPreviousUrl: "",
          insightsTotalArticles: 0,
          insightsTotalResults: {},
          insightsCurrentPage: 0,
          insightsPageOffset: 0,
          articlePageOffset: 0,
          PDBIncludeKeywords: [],
          PDBExcludeKeywords: [],
          insightsIncludeKeywords: [],
          insightsExcludeKeywords: [],
          suggestions: [],
          topic:null,
          glocalModuleLoader: false,
          selectedModule: 'Trending News',
          trendingNewsFilter:{
            searchedKeyword: '',
            startDate:'',
            endDate: '',
            includedKeywords: [],
            excludedKeywords: [],
            exactKeyword: '',
            includedSources: [],
            excludedSources: [],
            pageOffSet: 0,
            sortBy: 'recency'
          },
          trendingResearchFilter:{
            startDate:'',
            endDate: '',
            includedKeywords: [],
            excludedKeywords: [],
            exactKeyword: '',
            includedSources: [],
            excludedSources: [],
            pageOffSet: 0,
            sortBy: 'recency'
          },
          activeTopicTab: 'Trending news',
          pdbExactKeyword:'',
          insightExactKeyword: '',
          activeTopicDiscussionTypeId: '', // it can be either an id of public or private
          openInitialTopicModal: false,
          sourcesByCountry: [],
          insightSourcesByCountry: [],
          initialJobId: null,
          topicNonInvitedUsers: [],
          discoverScrollPosition: 0,
          yourPDBKeywordsMissing: false, // use to open topic modal for the users which do not have your PDB keywords,
          actNowSelectedAuthorities: [],
          actNowAuthorities: {},
          actNowChat:[
            {
              chat:`<h4>
          <p>Your Name</p>
          <p>[Your Address]</p>
          <p>[City, State ZIP Code]</p>
          <p>[Email Address]</p>
          <p>[Phone Number]</p>
          <p>[Date]</p>
          <p>The Honorable [Senator's Full Name]</p>
          <p>[Office Address of the Senator]</p>
          <p>[City, State ZIP Code]</p>

          <p>Dear Senator [Last Name],</p>

          <p>
            I am writing to you as a concerned resident of [your city/state] and
            a constituent in your district. I appreciate your service to our
            state and the work you do representing our interests in the U.S.
            Senate.
          </p>

          <p>
            I would like to express my concern regarding [briefly state the
            issue — e.g., climate change, student loan debt, healthcare, gun
            control, etc.]. This issue is of great importance to me because
            [briefly explain your personal connection or why it matters to you
            and your community].
          </p>

          <p>
            I respectfully urge you to [state the action you would like the
            senator to take — e.g., support or oppose a specific bill, allocate
            funding, push for hearings, etc.]. I believe this action is
            essential for the well-being of [your community, state, or the
            nation], and I hope you will consider the voices of your
            constituents when making decisions on this matter.
          </p>

          <p>
            Thank you for your time and for your continued service to our state.
            I would be grateful for a response to understand your position on
            this issue.
          </p>

          <p>Sincerely,</p>
          <p>[Your Full Name]</p>
              </h4>`,
              id: 1
            }
          ]
        };
    },
    actions,
    mutations,
    getters
}